import Api from '@common/services/api';

export const deleteCompetancy = async (
  organisationId: string,
  competencyId: string
) => {
  await Api.delete(
    `/v1/organisations/${organisationId}/performance/competencies/${competencyId}`
  );
};
